






































































































































































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import AlertArea from "../../components/AlertArea.vue"
import CustomConfirmModal from "../../components/CustomConfirmModal.vue"
import { BaseSheet } from "../../modules/teacher/BaseSheetEdit"

export interface Data {
  base_sheet_id: string
  baseSheet: BaseSheet | null
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    const CorrectImagePublishRangeEnum = Common.CorrectImagePublishRangeEnum;
    const CorrectImagePublishTriggerEnum = Common.CorrectImagePublishTriggerEnum;

    const customConfirmModalRef = ref<InstanceType<typeof CustomConfirmModal>>();

    const state = reactive<Data>({
      base_sheet_id: null,
      baseSheet: null,
      errors: [],
    });

    const updateClick = async () => {
      state.errors = [];

      if(!state.baseSheet.sheet_code){
        state.errors.push("レポートIDを入力してください。");
      }

      if(!state.baseSheet.nendo){
        state.errors.push("年度を入力してください。");
      }else if(!new RegExp(/^[0-9]+$/).test(state.baseSheet.nendo)){
        state.errors.push("年度は半角整数で入力してください。");
      }else if(`${Number(state.baseSheet.nendo)}`.length != 4){
        state.errors.push("年度は西暦4桁で入力してください。");
      }

      if(!state.baseSheet.subject_code){
        state.errors.push("科目を入力してください。");
      }

      if(!state.baseSheet.report_no){
        state.errors.push("レポートNoを入力してください。");
      }else if(!new RegExp(/^[0-9]+$/).test(state.baseSheet.report_no)){
        state.errors.push("レポートNoは半角整数で入力してください。");
      }else if(state.baseSheet.report_no > context.root.$store.state.subjects.filter((x: any) => x.subject_code == state.baseSheet.subject_code)[0].report_count){
        state.errors.push("レポートNoが科目マスタに登録されている回数を超過しています。");
      }

      if(!state.baseSheet.name){
        state.errors.push("レポート名を入力してください。");
      }

      if(!Common.isInteger(state.baseSheet.passing_score)){
        state.errors.push("合格点を入力してください。");
      }else if(!Common.isInteger(state.baseSheet.passing_score)){
        state.errors.push("合格点には整数を入力してください。");
      }else if(parseInt(state.baseSheet.passing_score) < 0){
        state.errors.push("合格点には0点以上の整数を入力してください。");
      }

      if(!state.baseSheet.qr_code){
        state.errors.push("QRコードを入力してください。");
      }

      if(!context.root.$store.getters.isOptionStudentSubjectReportActive && state.baseSheet.is_correct_image_publish){
        if(state.baseSheet.correct_image_publish_trigger == CorrectImagePublishTriggerEnum.Unpublished && !state.baseSheet.final_deadline_at){
          state.errors.push("模範解答の公開日時に「最終締切日時後」を選択している場合、最終締め切り日時を設定してください。")
        }
      }

      if(state.errors.length > 0){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(state.baseSheet.requiresFollowUpSetting){
        // 得点枠の再設定が必要な場合に注意を促す確認メッセージを表示
        customConfirmModalRef.value.show();
      }else if(window.confirm("レポート情報を更新します。よろしいですか？")){
        await update();
      }
    }

    const update = async () => {

      // 得点枠設定が必要＋既に公開済みの場合、非公開に戻す
      if(state.baseSheet.requiresFollowUpSetting && state.baseSheet.is_published){
        state.baseSheet.is_published = false;
      }

      customConfirmModalRef.value.hide();

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/base_sheet_edit/update/${state.base_sheet_id}`, {base_sheet: state.baseSheet}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        window.scroll({top: 0, behavior: 'smooth'});
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/base_sheet_edit?base_sheet_id=${state.base_sheet_id}`).then(response => {
        state.baseSheet = new BaseSheet(response.data.base_sheet);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      CorrectImagePublishRangeEnum,
      CorrectImagePublishTriggerEnum,
      customConfirmModalRef,
      updateClick,
      update,
    }
  },
})
